"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FocusManagerWithArrowKeyNavigation = require("./FocusManagerWithArrowKeyNavigation");
Object.keys(_FocusManagerWithArrowKeyNavigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FocusManagerWithArrowKeyNavigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FocusManagerWithArrowKeyNavigation[key];
    }
  });
});